export type UpgradeRoleInput = {
  subscriptionId?: number | string | null;
  isOwner: boolean;
  isReseller: boolean;
  isSeatUser: boolean;
  flagOn: boolean;
};

// Single source of truth for "given these role facts, where should the primary
// upgrade CTA point?". Consumed by useUpgradeTarget (raw DTO shape) and by
// SubscriptionDetails (extracted DTO shape), so both cannot drift.
export const resolveUpgradeTarget = ({
  subscriptionId,
  isOwner,
  isReseller,
  isSeatUser,
  flagOn,
}: UpgradeRoleInput): string | null => {
  if (subscriptionId == null) return null;
  if (isReseller) return null;
  if (flagOn) {
    return isOwner || isSeatUser
      ? `/subscriptions/${subscriptionId}/upgrade-request`
      : null;
  }
  return isOwner ? "/upgrade" : null;
};
